import { render } from "./GradeScore.vue?vue&type=template&id=7ef73a1b&scoped=true&ts=true&lang=pug"
import script from "./GradeScore.vue?vue&type=script&lang=ts"
export * from "./GradeScore.vue?vue&type=script&lang=ts"

import "./GradeScore.vue?vue&type=style&index=0&id=7ef73a1b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef73a1b"]])

export default __exports__